export default class API {
    sort = $('.results__container #sort-order')
    searchContainer = $('.search__search')

    constructor() {
        this.initDropdowns()
        this.initMultidropdowns()
    }

    initMultidropdowns() {
        let _t = this
        _t.searchContainer.find('.control--checkbox').each((i, e) => {
            $(e).find('input').on('change', function() {
                $(e).toggleClass('checked', $(this).is(':checked'))
                _t.updateMultiDropdownLabel($(e).closest('.multi-select-dropdown'))
            })

            if($(e).find('input').is(':checked')) $(e).addClass('checked')
        })

        _t.searchContainer.find('.multi-select').each((i, e) => {
            let label = $(e).find('.label');

            label.on('click', function() {
                _t.searchContainer.find('.multi-select .label').not($(this)).removeClass('open').next('.multi-select-dropdown').fadeOut(200);

                if($(this).hasClass('open')) {
                    $(this).next('.multi-select-dropdown').fadeOut(200)
                    $(this).removeClass('open')
                } else {
                    $(this).next('.multi-select-dropdown').fadeIn(200)
                    $(this).addClass('open')
                }
            })
        })

        _t.searchContainer.find('.multi-select-dropdown .reset').on('click', function(){
            $(this).next('.options').find('label').removeClass('checked')
            $(this).next('.options').find('input').prop('checked', false)
            _t.updateMultiDropdownLabel($(this).closest('.multi-select-dropdown'))
        })
    }

    initDropdowns() {
        this.searchContainer.find('select').each((i, e) => $(e).customSelect())
        this.sort.customSelect()
    }

    updateMultiDropdownLabel(multiselect) {
        let count = multiselect.find('input:checked').length
        let label = multiselect.prev('.label')
        count ? label.find('.selected').html(` (${count})`) : label.find('.selected').html('')
    }

    scrollToTop() {
        $('html, body').animate({ scrollTop: $('.results__container').offset().top - 200 }, 1000)
    }

    fetchTemplate(endpoint) {
        return new Promise((resolve, reject) => {
            $.get(endpoint, (res) => {
                resolve(res.template)
            })
        })
    }

    fetchAPI(endpoint, queryParams) {
        return new Promise((resolve, reject) => {
            if(queryParams['keyword']) history.replaceState(null, null, "?q="+queryParams['keyword'].toString());
            
            $.ajax({
                url: endpoint,
                method: 'GET',
                data: queryParams,
                beforeSend: () => {
                },
                success: (response) => {
                    resolve(response)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    renderPagination(totalPages, current) {
        let currentPage = parseInt(current);
        this.paginationContainer.empty();
        
        if (totalPages > 1) {
            // Previous button
            if (currentPage > 1) {
                this.paginationContainer.append(
                    `<a href="#" data-page="${currentPage - 1}" class="arrow prev" title="Previous"><span uk-icon="icon:chevron-left; ratio: 1.2;"></span></a>`
                );
            }
    
            // Calculate the range of page numbers to show
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(totalPages, currentPage + 2);
    
            // Adjust start and end pages if there are fewer than 5 pages to display
            if (endPage - startPage < 4) {
                if (startPage > 1) {
                    endPage = Math.min(totalPages, startPage + 4);
                } else {
                    endPage = Math.min(totalPages, 5);
                }
            }
    
            // Display page numbers
            for (let i = startPage; i <= endPage; i++) {
                this.paginationContainer.append(
                    `<a href="#" data-page="${i}" class="${i === currentPage ? 'active' : ''}">${i}</a>`
                );
            }
    
            // Add ellipsis if there are pages before the start page
            if (startPage > 1) {
                this.paginationContainer.prepend(
                    `<span class="ellipsis">...</span>`
                );
            }
    
            // Add ellipsis if there are pages after the end page
            if (endPage < totalPages) {
                this.paginationContainer.append(
                    `<span class="ellipsis">...</span>`
                );
            }
    
            // Next button
            if (currentPage < totalPages) {
                this.paginationContainer.append(
                    `<a href="#" data-page="${currentPage + 1}" class="arrow next" title="Next"><span uk-icon="icon:chevron-right; ratio: 1.2;"></span></a>`
                );
            }
        }
    }
}